module.exports = __webpack_public_path__ + "img/130.8.5df90c38.png";